(() => {
  const STORAGE_KEY = 'rv:handles';
  const MAX_STORED = 20;
  const MAX_RENDER = 10;
  // Storefront root: '/' on the main market, '/en-gb/' on a Markets subfolder.
  // A root-path request from a subfolder page is served as the US market (USD
  // prices, and /cart.js switches the cart's currency cookie), so every
  // storefront URL below is built from it.
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const docBody = document.body;
  const currency = (docBody && docBody.dataset && docBody.dataset.currency) || 'USD';
  const locale = (docBody && docBody.dataset && docBody.dataset.locale) || (document.documentElement.lang || 'en');

function formatMoney(cents) {
  try {
    return new Intl.NumberFormat(locale || 'en-US', {
      style: 'currency',
      currency: currency || 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format((cents || 0) / 100);
  } catch (e) {
    // fallback
    return `$${Math.floor(cents / 100)}`;
  }
}

  function normalizeHandle(handle) {
    return (handle || '').toString().trim().toLowerCase();
  }

  function unique(arr) {
    return [...new Set(arr.map(normalizeHandle).filter(Boolean))];
  }

  let currentRender = 0;

  function readHandles() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
      return [];
    }
  }

  function writeHandles(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_STORED)));
    } catch (_) {}
  }

  // Tracker for product pages
  document.addEventListener('DOMContentLoaded', () => {
    const el = document.querySelector('[data-product-handle]');
    const handle = el && el.getAttribute('data-product-handle');
    if (handle) {
      const list = readHandles().map(normalizeHandle);
      const normalized = normalizeHandle(handle);
      if (normalized) {
        const next = [normalized, ...list.filter((h) => h !== normalized)];
        writeHandles(next);
      }

      // Track variant selections on product page
      const updateVariant = () => {
         const params = new URLSearchParams(window.location.search);
         const vId = params.get('variant');
         if (vId) {
             try {
                const sv = JSON.parse(localStorage.getItem('rv:saved-variants') || '{}');
                sv[normalizeHandle(handle)] = vId;
                localStorage.setItem('rv:saved-variants', JSON.stringify(sv));
             } catch(e){}
         }
      };
      updateVariant();
      window.addEventListener('popstate', updateVariant);
      document.addEventListener('change', (e) => {
          if (e.target.closest('variant-selects') || e.target.closest('variant-radios')) {
              setTimeout(updateVariant, 50);
          }
      });
    }
  });

  // Cache product payloads for the session. Cart re-renders recreate the upsell
  // container and re-mount, so without this every add/remove re-fetches each
  // product over the network — that round-trip is what makes the panel flash.
  const productCache = new Map();

  async function fetchProduct(handle) {
    const key = normalizeHandle(handle);
    if (key && productCache.has(key)) return productCache.get(key);
    const res = await fetch(`${ROOT}products/${handle}.js`);
    if (!res.ok) throw new Error('Fetch error');
    const data = await res.json();
    if (key) productCache.set(key, data);
    return data;
  }

  function setupQuickAdd(cardElement, product) {
    const quickAddBtn = cardElement.querySelector('[data-rvc-quick-add-trigger]');
    const errorDiv = cardElement.querySelector('[data-rvc-error]');

    if (!quickAddBtn || !product || !product.variants) return;

    quickAddBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      let targetVariant = null;

      if (product.variants.length === 1) {
        targetVariant = product.variants[0];
      } else {
        try {
          const handle = normalizeHandle(product.handle);
          const savedVariants = JSON.parse(localStorage.getItem('rv:saved-variants') || '{}');
          if (savedVariants[handle]) {
             targetVariant = product.variants.find(v => String(v.id) === String(savedVariants[handle]));
          }
          if ((!targetVariant || !targetVariant.available) && localStorage.getItem('rv:preferred-options')) {
             const prefs = JSON.parse(localStorage.getItem('rv:preferred-options'));
             let bestMatchCount = -1;
             const optionNames = (product.options || []).map(o => typeof o === 'string' ? o : o.name);
             product.variants.forEach(v => {
                 if (!v.available) return;
                 let matchCount = 0;
                 v.options.forEach((optValue, idx) => {
                     const optName = optionNames[idx];
                     if (prefs[optName] === optValue) matchCount++;
                 });
                 if (matchCount > bestMatchCount) {
                     bestMatchCount = matchCount;
                     targetVariant = v;
                 }
             });
          }
        } catch(err) {}

        if (!targetVariant || !targetVariant.available) {
           targetVariant = product.variants.find(v => v.available) || product.variants[0];
        }
      }

      if (targetVariant && targetVariant.available) {
        addToCartAjax(targetVariant, quickAddBtn, errorDiv);
      } else {
        showError(errorDiv, 'Selected size is sold out or unavailable');
      }
    });
  }

  function getVariantAddLabel(variant) {
    if (!variant) return 'Add to cart';
    const qty = determineInitialQuantity(variant);
    return qty > 1 ? `Add ${qty} to cart` : 'Add to cart';
  }

  function updateAddToCartButton(button, variant) {
    if (!variant) {
      button.disabled = true;
      button.textContent = 'Select options';
    } else if (!variant.available) {
      button.disabled = true;
      button.textContent = 'Sold out';
    } else {
      button.disabled = false;
      button.textContent = getVariantAddLabel(variant);
    }
  }


  function determineInitialQuantity(variant) {
    if (!variant || !variant.quantity_rule) return 1;
    const rule = variant.quantity_rule || {};
    const min = Number.parseInt(rule.min, 10);
    const increment = Number.parseInt(rule.increment, 10);

    if (Number.isFinite(min) && min > 0) return min;
    if (Number.isFinite(increment) && increment > 0) return increment;
    return 1;
  }

  function normalizeQuantityError(message, variant) {
    if (!message || !variant || !variant.quantity_rule) return message;
    const rule = variant.quantity_rule || {};
    const rawStep = rule.increment ?? rule.min ?? rule.max;

    let replacement = '';
    const numericStep = Number.parseInt(rawStep, 10);
    if (Number.isFinite(numericStep) && numericStep > 0) {
      replacement = String(numericStep);
    } else if (typeof rawStep === 'string' && rawStep.trim() !== '') {
      replacement = rawStep.trim();
    } else {
      const fallback = determineInitialQuantity(variant);
      replacement = fallback > 0 ? String(fallback) : '1';
    }

    return message.replace(/undefined/gi, replacement);
  }

  function addToCartAjax(variant, button, errorDiv) {
    if (!variant || !variant.id) {
      showError(errorDiv, 'Please select a variant');
      return;
    }

    const variantId = variant.id;
    const quantity = determineInitialQuantity(variant);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    hideError(errorDiv);

    const cartElement = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    if (cartElement && typeof cartElement.setActiveElement === 'function') {
      cartElement.setActiveElement(button);
    }

    const formData = new FormData();
    formData.append('form_type', 'product');
    formData.append('utf8', '✓');
    formData.append('id', variantId);
    formData.append('quantity', String(quantity));
    if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
      const sectionsToRender = cartElement.getSectionsToRender().map((section) => section.id);
      if (sectionsToRender.length) {
        formData.append('sections', sectionsToRender);
        formData.append('sections_url', window.location.pathname);
      }
    }

    fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: formData
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => Promise.reject(err));
      }
      return response.json();
    })
    .then(response => {
      if (response.status) {
        // if (typeof publish !== 'undefined') {
        //   publish(PUB_SUB_EVENTS.cartError, {
        //     source: 'recently-viewed-quick-add',
        //     productVariantId: variantId,
        //     errors: response.errors || response.description,
        //     message: response.message,
        //   });
        // }
        let errorMessage = response.description || response.message || 'Failed to add to cart';
        errorMessage = normalizeQuantityError(errorMessage, variant);

        button.disabled = false;
        button.removeAttribute('aria-busy');
        return;
      }

      // The button keeps its + icon throughout; aria-busy marks the wait.

      // Use the same cart update pattern as product-form
      const startMarker = typeof CartPerformance !== 'undefined'
        ? CartPerformance.createStartingMarker('add:wait-for-subscribers')
        : null;
      // Coalesces with the `recently-viewed:refresh` renderContents dispatches at
      // the same moment, so the two fire one mount between them.
      const scheduleMountRefresh = () => scheduleMount(MOUNT_COALESCE_MS);
      const renderCartContents = () => {
        if (cartElement && cartElement.classList.contains('is-empty')) {
          cartElement.classList.remove('is-empty');
        }
        const drawerInner = cartElement && cartElement.querySelector && cartElement.querySelector('.drawer__inner');
        if (drawerInner && drawerInner.classList.contains('is-empty')) {
          drawerInner.classList.remove('is-empty');
        }
        if (
          cartElement &&
          typeof cartElement.renderContents === 'function' &&
          response &&
          response.sections
        ) {
          if (typeof CartPerformance !== 'undefined') {
            CartPerformance.measure('add:paint-updated-sections', () => {
              cartElement.renderContents(response);
            });
          } else {
            cartElement.renderContents(response);
          }
        }
        scheduleMountRefresh();
      };

      if (typeof publish !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'recently-viewed-quick-add',
          productVariantId: variantId,
          cartData: response,
        }).then(() => {
          if (startMarker && typeof CartPerformance !== 'undefined') {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          }
          renderCartContents();
        });
      } else {
        renderCartContents();
      }

      // Reset button after delay
      setTimeout(() => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }, 2000);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      showError(errorDiv, error.description || error.message || 'Failed to add to cart');
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
  }

  function showError(errorDiv, message) {
    if (!errorDiv) return;
    errorDiv.textContent = message;
    errorDiv.classList.add('is-visible');
  }

  function hideError(errorDiv) {
    if (!errorDiv) return;
    errorDiv.textContent = '';
    errorDiv.classList.remove('is-visible');
  }


  // Product handles currently in the cart, so upsells already added can be
  // dropped from the list (and reappear if the shopper removes them). Resolves
  // to an empty set on failure, leaving the list unfiltered as before.
  function getInCartHandles() {
    return fetch(`${ROOT}cart.js`, { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => new Set(((cart && cart.items) || []).map((it) => normalizeHandle(it.handle)).filter(Boolean)))
      .catch(() => new Set());
  }

  // Resolve the list of product handles to show, based on the upsell source
  // chosen in the customizer (data-upsell-source on the block).
  function resolveUpsellHandles(mode, wrap) {
    if (mode === 'collection') {
      const fallback = () =>
        (wrap.dataset.upsellHandles || '').split(',').map(normalizeHandle).filter(Boolean);
      const handle = wrap.dataset.upsellCollection;
      if (!handle) return Promise.resolve(fallback());
      const limit = parseInt(wrap.dataset.upsellLimit, 10) || MAX_RENDER;
      // Fetch with explicit manual sort so the merchant's drag-arranged
      // collection order is honored. Liquid's collection.products does not
      // reliably reflect manual order in this global (layout) context, and a
      // live fetch also picks up admin reorders without a theme re-render.
      // A few spare products: anything already in the cart is dropped later,
      // and the row should still fill to its limit (renderUpsellCards slices).
      return fetch(`${ROOT}collections/${handle}/products.json?sort_by=manual&limit=${limit + 10}`, {
        headers: { Accept: 'application/json' },
      })
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => {
          const handles = ((d && d.products) || []).map((p) => normalizeHandle(p.handle)).filter(Boolean);
          return handles.length ? handles : fallback();
        })
        .catch(fallback);
    }
    if (mode === 'recommended') {
      return fetchRecommendedHandles(wrap);
    }
    return Promise.resolve(unique(readHandles()));
  }

  // Shopify recommendations are keyed to a product, so base them on the cart's
  // first line item. Complementary ("goes-with") first, then related as a
  // fallback. Anything already in the cart is excluded.
  function fetchRecommendedHandles(wrap) {
    const limit = parseInt(wrap.dataset.upsellLimit, 10) || MAX_RENDER;
    let base = wrap.dataset.recoUrl || `${ROOT}recommendations/products`;
    if (!/\.json($|\?)/.test(base)) base += '.json';

    return fetch(`${ROOT}cart.js`, { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        const items = (cart && cart.items) || [];
        if (!items.length) return [];
        const productId = items[0].product_id;
        const inCart = new Set(items.map((it) => normalizeHandle(it.handle)));
        const get = (intent) =>
          fetch(`${base}?product_id=${productId}&limit=${limit}&intent=${intent}`, {
            headers: { Accept: 'application/json' },
          })
            .then((r) => (r.ok ? r.json() : null))
            .then((d) => (d && d.products) || []);

        return get('complementary')
          .then((products) => (products.length ? products : get('related')))
          .then((products) =>
            products.map((p) => normalizeHandle(p.handle)).filter((h) => h && !inCart.has(h))
          );
      })
      .catch(() => []);
  }

  // Shared render path for all sources: fetch each product and build cards.
  function renderUpsellCards(wrap, track, drawer, mode, handles) {
    const tpl = wrap.querySelector('#rvc-card-template');
    const limit = parseInt(wrap.dataset.upsellLimit, 10) || MAX_RENDER;
    const toLoad = handles.slice(0, Math.min(limit, MAX_RENDER));
    const renderId = ++currentRender;

    Promise.allSettled(toLoad.map(fetchProduct)).then((results) => {
      if (renderId !== currentRender) return;

      const seen = new Set();
      const appendedHandles = [];
      const failedHandles = new Set();
      const fragment = document.createDocumentFragment();

      // Cards already on screen are reused by handle, so a refresh after a cart
      // change only adds or drops the cards that changed. Rebuilding every card
      // re-created every <img>, and each one repainted -- part of the flash.
      const existing = new Map();
      track.querySelectorAll('[data-rvc-card]').forEach((card) => {
        existing.set(card.getAttribute('data-rvc-handle'), card);
      });

      results.forEach((r, index) => {
        if (r.status !== 'fulfilled') {
          const failedHandle = normalizeHandle(toLoad[index]);
          if (failedHandle) failedHandles.add(failedHandle);
          return;
        }
        const p = r.value;
        const handle = normalizeHandle(p && p.handle ? p.handle : toLoad[index]);
        if (!handle || seen.has(handle)) return;
        seen.add(handle);

        if (existing.has(handle)) {
          fragment.appendChild(existing.get(handle));
          appendedHandles.push(handle);
          return;
        }

        const node = tpl.content.cloneNode(true);
        const card = node.querySelector('[data-rvc-card]');
        const nameLink = node.querySelector('[data-rvc-link]');
        const img = node.querySelector('[data-rvc-img]');
        const name = node.querySelector('[data-rvc-name]');
        const priceCurrent = node.querySelector('[data-rvc-current]');
        const priceCompare = node.querySelector('[data-rvc-compare]');
        card.setAttribute('data-rvc-handle', handle);
        nameLink.href = p.url || `${ROOT}products/${handle}`;
        if (p.images && p.images[0]) {
          img.src = p.images[0];
          img.alt = p.title || '';
        } else {
          img.removeAttribute('src');
        }

        const beforeDot = (p.title || '').split('.')[0].trim();
        name.textContent = beforeDot;

        // a11y: the quick-add button holds only a decorative SVG. The Liquid template
        // seeds a translated fallback ("Quick add"); keep it as the prefix so the
        // product-specific name below stays localized.
        const quickAddTrigger = node.querySelector('[data-rvc-quick-add-trigger]');
        if (quickAddTrigger) {
          const quickAddLabel = quickAddTrigger.getAttribute('aria-label') || '';
          const quickAddTitle = (p.title || beforeDot || '').trim();
          if (quickAddTitle) {
            quickAddTrigger.setAttribute(
              'aria-label',
              quickAddLabel ? `${quickAddLabel}: ${quickAddTitle}` : quickAddTitle
            );
          }
        }
        const cents = (p.price_min != null ? p.price_min : p.price) || 0;
        const compareCents = p.compare_at_price || 0;
        priceCurrent.textContent = formatMoney(cents);
        // Match the main-site card: show the compare-at price struck through
        // only when it's genuinely higher than the current price.
        if (compareCents > cents) {
          priceCompare.textContent = formatMoney(compareCents);
          priceCompare.hidden = false;
        }

        // Setup quick add functionality
        setupQuickAdd(card, p);

        fragment.appendChild(node);
        appendedHandles.push(handle);
      });

      if (!appendedHandles.length) {
        if (!track.children.length) {
          wrap.hidden = true;
          drawer?.classList.remove('has-recently-viewed');
        }
        return;
      }

      // replaceChildren moves reused cards rather than re-creating them, so
      // their images stay painted.
      track.replaceChildren(fragment);

      // Reveal now that real cards exist. Animate the entrance only on first
      // appearance (when the drawer isn't already flagged) so routine cart
      // re-renders refill in place without re-fading.
      const wasShowing = !!drawer && drawer.classList.contains('has-recently-viewed');
      wrap.hidden = false;
      drawer?.classList.add('has-recently-viewed');
      if (!wasShowing) {
        wrap.classList.add('rvc--enter');
        // Drop the class once it has played: re-inserting the row (see
        // adoptBuiltRow) would otherwise restart the animation on every cart change.
        wrap.addEventListener('animationend', () => wrap.classList.remove('rvc--enter'), { once: true });
      }

      // Prune only handles whose product fetch failed (deleted/unpublished)
      // from the persisted recently-viewed list. Read the full stored list
      // directly so items filtered out for being in the cart — or sitting
      // beyond the render window — are preserved.
      if (mode === 'recently_viewed' && failedHandles.size) {
        const stored = readHandles().map(normalizeHandle).filter(Boolean);
        const updatedHandles = stored.filter((handle) => !failedHandles.has(handle));
        if (updatedHandles.length !== stored.length) {
          writeHandles(updatedHandles);
        }
      }
    });
  }

  function mountRecentlyViewed(root) {
    const container = root || document;
    const wrap = container.querySelector('#CartDrawer-RecentlyViewed');
    if (!wrap) return;
    const track = wrap.querySelector('[data-rvc-track]');
    if (!track) return;
    const drawer = wrap.closest('cart-drawer');
    const mode = wrap.dataset.upsellSource || 'recently_viewed';

    // Claim this mount; a stale async source (e.g. a recommendations fetch from
    // a previous cart state) bails when a newer mount supersedes it.
    const mountId = ++currentRender;

    Promise.all([resolveUpsellHandles(mode, wrap), getInCartHandles()]).then(([rawHandles, inCart]) => {
      if (mountId !== currentRender) return;
      // Drop anything already in the cart so an added upsell falls off the list
      // (and a removed one returns). Recommended mode already filters in-cart;
      // recently-viewed and collection sources rely on this.
      const handles = unique(rawHandles).filter((handle) => !inCart.has(handle));
      if (!handles.length) {
        track.innerHTML = '';
        wrap.hidden = true;
        drawer?.classList.remove('has-recently-viewed');
        return;
      }
      // Build the cards before revealing — renderUpsellCards flips `hidden`
      // off only once real cards exist, so the panel animates in fully formed
      // instead of flashing empty and then growing as products arrive.
      renderUpsellCards(wrap, track, drawer, mode, handles);
    });
  }

  /*
   * Keep the built upsell row across drawer re-renders.
   *
   * The cards are built here, in the browser, but every cart change re-renders
   * the drawer from the server (add to cart, a quantity change, a variant
   * change, and the automatic shipping-protection add on a first cart). Each
   * re-render replaced the finished row with the server's empty, `hidden`
   * placeholder, so the row vanished and only came back once the next mount
   * had fetched and rebuilt it: after a quantity change it was gone for about
   * two seconds, and a first add-to-cart showed it, wiped it and showed it
   * again. That was the "upsells flash twice" report (2026-10-09).
   *
   * Now the placeholder is swapped for the row that is already built, inside a
   * MutationObserver callback. Those run as a microtask straight after the DOM
   * write, before the browser paints, so no frame ever shows the gap. The
   * scheduled mount then refreshes the cards in place (renderUpsellCards reuses
   * cards by handle), dropping anything that has just been added to the cart.
   */
  let builtRow = null;

  function adoptBuiltRow() {
    const fresh = document.getElementById('CartDrawer-RecentlyViewed');
    if (!fresh || fresh === builtRow) return;
    if (builtRow && !builtRow.isConnected && !builtRow.hidden && builtRow.querySelector('[data-rvc-card]')) {
      builtRow.classList.remove('rvc--enter');
      fresh.replaceWith(builtRow);
      return;
    }
    // Nothing worth keeping yet: remember whichever row is live, so the next
    // re-render can keep it once it has cards.
    builtRow = fresh;
  }

  function watchDrawer() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.__rvcWatched) return;
    drawer.__rvcWatched = true;
    builtRow = document.getElementById('CartDrawer-RecentlyViewed');
    new MutationObserver(adoptBuiltRow).observe(drawer, { childList: true, subtree: true });
  }

  /*
   * One mount per cart change.
   *
   * Three things used to mount independently on a single add-to-cart, measured
   * at +37ms, +648ms and +648ms: the cartUpdate subscriber, the
   * `recently-viewed:refresh` event, and addToCartAjax's own refresh. The two
   * late ones are the same moment; the early one is worse than redundant,
   * because it renders cards into drawer DOM that renderContents replaces about
   * 600ms later -- the upsell row appears, is wiped with the DOM, then rebuilds.
   * That is the "loading twice" flicker, and each extra mount also costs a
   * /cart.js plus a collection fetch.
   *
   * Everything now goes through one cancellable timer, so a burst collapses to
   * a single mount. cartUpdate schedules a LATE fallback instead of mounting
   * immediately: every theme path that replaces drawer DOM dispatches
   * `recently-viewed:refresh` right after (cart.js after the section swap,
   * cart-drawer.js in renderContents), and those cancel and re-schedule this at
   * 0. The fallback only ever fires if some future path publishes cartUpdate
   * without re-rendering the drawer, so the upsell can't go stale.
   *
   * setTimeout, not requestAnimationFrame: rAF is paused in background tabs, and
   * this work must run regardless of visibility.
   */
  const MOUNT_COALESCE_MS = 0;
  const MOUNT_FALLBACK_MS = 800;
  let pendingMountTimer = null;

  function scheduleMount(delay) {
    if (pendingMountTimer !== null) clearTimeout(pendingMountTimer);
    pendingMountTimer = setTimeout(() => {
      pendingMountTimer = null;
      mountRecentlyViewed(document.getElementById('CartDrawer') || document);
    }, delay);
  }

  // Run when drawer content is present
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.getElementById('CartDrawer') || document;
    watchDrawer();
    mountRecentlyViewed(root);
  });
  // Also re-run after cart updates (drawer re-render)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.cartData && event.cartData.items) {
          try {
             const savedVariants = JSON.parse(localStorage.getItem('rv:saved-variants') || '{}');
             const preferredOptions = JSON.parse(localStorage.getItem('rv:preferred-options') || '{}');
             event.cartData.items.forEach(item => {
                 savedVariants[normalizeHandle(item.handle)] = item.variant_id;
                 if (item.options_with_values) {
                     item.options_with_values.forEach(o => {
                         preferredOptions[o.name] = o.value;
                     });
                 }
             });
             localStorage.setItem('rv:saved-variants', JSON.stringify(savedVariants));
             localStorage.setItem('rv:preferred-options', JSON.stringify(preferredOptions));
          } catch(e) {}
      }

      // Late fallback: a `recently-viewed:refresh` from the re-render normally
      // cancels this and mounts at 0 instead. See scheduleMount above.
      scheduleMount(MOUNT_FALLBACK_MS);
    });
  }

  document.addEventListener('recently-viewed:refresh', () => {
    scheduleMount(MOUNT_COALESCE_MS);
  });
})();
